export default __webpack_public_path__ + "images/f4781df6754635ef52cfb80c84795b40-newyearseve.webp";